import api from '@/sui/api/api'

let module = null

const remote = true
if (remote) {
  module = {
    get (request) {
      return api.post('/cloud', request)
    }
  }
}

export default module
